export default "__VITE_ASSET__4NxqmSZd__"